import React, {useRef} from 'react';
import {ManagementMobileComponent} from './ManagementMobile.style';
import fire from '../../../../public/image/WhyUs/Panoramic/mobile/fire.webp';
import hand from '../../../../public/image/WhyUs/Panoramic/mobile/hand.webp';
import hands from '../../../../public/image/WhyUs/Panoramic/mobile/hands.webp';
import people from '../../../../public/image/WhyUs/Panoramic/mobile/people.webp';

const ManagementMobile = ({active}) => {
  const wrap = useRef();

  return (
    <ManagementMobileComponent
      secHeight={active ? wrap.current?.clientHeight : 0}>
      <div className='management' ref={wrap}>
        <img src={fire.src} alt='' className='managementmobile__bg' />
        <div className='managementmobile__header'>
          <p className='managementmobile__header--text'>
            Panoramic HR <br /> Management
          </p>
          <img
            src={hand.src}
            alt=''
            className='managementmobile__header--img'
          />
        </div>
        <div className='managementmobile__purple'>
          <img
            src={hands.src}
            alt=''
            className='managementmobile__purple--hands'
          />
        </div>
        <div className='managementmobile__section'>
          <p className='managementmobile__section--header'>
            Complete Business <br /> Value Chain
          </p>
          <div className='managementmobile__section--content'>
            <p>
              The model aims to deliver a unique value of{' '}
              <span>strategic HR management</span> instead of a traditional,
              tactical one.
            </p>
            <p>
              <span>Our HR professionals</span> empower such model with their
              diversified backgrounds from several industries to form a team
              that entails{' '}
              <span>
                numerous sub-specializations across various HR functions.
              </span>
            </p>
            With an <span>extended digital infrastructure</span>, we ensure to
            digitally trace such journey from a pre-entry phase until the exit
            point in a <span>systematic pattern.</span>
          </div>
        </div>
        <div className='managementmobile__purple'>
          <img
            src={people.src}
            alt=''
            className='managementmobile__purple--hands managementmobile__purple--hands2'
          />
        </div>
        <div className='managementmobile__section'>
          <p className='managementmobile__section--header'>
            Prioritization of <br /> Capabilities Development
          </p>
          <div className='managementmobile__section--content managementmobile__section--content2'>
            <p>
              The{' '}
              <span className='managementmobile__section--content-blue'>
                {'"LMS"'}
              </span>{' '}
              model prioritizes the exploration of professionals’ potentials and
              the development of their capabilities to{' '}
              <span>meet the market’s constantly changing needs.</span>
            </p>
            <span>{'"Growing From Within"'}</span> is a business philosophy that
            Electa Sourcing adopts and implements through the conduction of
            intensive internal trainings and employees development plans.
          </div>
        </div>
      </div>
    </ManagementMobileComponent>
  );
};

export default ManagementMobile;
